'use client';

import { useTranslations } from 'next-intl';

import { ErrorPage } from '@/components/ui/ErrorPage';

export default function NotFound() {
  const t = useTranslations();

  return (
    <ErrorPage
      title={t('get-feedback-notFound-title')}
      description={t('get-feedback-notFound-description')}
      ctaText={t('get-feedback-notFound-refresh')}
      ctaAction={() => window.location.reload()}
    />
  );
}
